import { startsWith, get } from 'lodash';

export const rootRouteDetector = route => {
  const pathname = get(window, 'location.pathname', '');
  return startsWith(pathname, `${route}/`) || route === pathname;
};
